"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../actions/internal/types");
function mediaReducer(state, action) {
    if (state === void 0) { state = {
        fetching: undefined,
        data: undefined
    }; }
    switch (action.type) {
        case types_1.InternalClientActionType.
            GET_MEDIA_DATA:
        case types_1.InternalClientActionType.
            GET_MEDIA_DATA_STARTED_POLLING:
            return __assign({}, state, { fetching: true });
        case types_1.InternalClientActionType.
            GET_MEDIA_DATA_UPDATE:
            return __assign({}, state, { data: action.results });
        case types_1.InternalClientActionType.
            GET_MEDIA_DATA_STOPPED_POLLING:
            return __assign({}, state, { fetching: false });
        default:
            return state;
    }
}
exports.mediaReducer = mediaReducer;
//# sourceMappingURL=mediaReducer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/reducers/mediaReducer.js
 ** module id = 2086
 ** module chunks = 0
 **/